import { CARD_CDN_URL } from "../utils/constants";
import { Link } from "react-router-dom";
import NO_IMG from "../icons/No_Image_Found.png";
import { useState } from "react";
import PLAY_BTN from "../icons/aimax-favicon-color.svg";

const MovieCard = ({ movie }) => {
  const [isHover, setIsHover] = useState(false);
  const { title, name, backdrop_path } = movie;
  // console.log(media_type)
  const handleOnMouseEnter = () => {
    setIsHover(true);
  };
  const handleOnMouseLeave = () => {
    setIsHover(false);
  };
  // if (!backdrop_path) return null;
  return (
    <div
      className="p-2 inline-block"
      onMouseEnter={handleOnMouseEnter}
      onMouseLeave={handleOnMouseLeave}
    >
      <Link className="" to={`/browse/movie/${movie.id}`}>
        <div className="w-64 md:w-60 lg:w-64">
          {/* {isHover  && <img src={PLAY_BTN} className="w-20"/>} */}

          <div className="relative hover:scale-105 ease-in-out duration-300 ">
            {backdrop_path ? (
              <img
                src={CARD_CDN_URL + backdrop_path}
                alt={title || name + " Card"}
                className={
                  !isHover
                    ? "rounded-xl shadow-sm  shadow-gray-700 "
                    : "brightness-75 rounded-xl shadow-sm  shadow-gray-700 "
                }
              />
            ) : (
              //eventhough i have flitered out backdrop null still last one check
              <div className="w-48 md:w-64 ">
                <img src={NO_IMG} alt="" className="rounded-xl opacity-15 " />
              </div>
            )}
            {isHover && (
              <div className="absolute w-full md:w-64 bg-gray-300 hidden lg:inline-block">
                <img
                  src={PLAY_BTN}
                  className="w-14 -mt-24 ml-24"
                  alt="Play Button"
                />
              </div>
            )}
          </div>

          <div className="p-1 ">
            <p className="text-white truncate opacity-70">{title || name}</p>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default MovieCard;
